import React, { Component } from 'react';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { postDataPromise } from 'brock-fetch-utils';
import { ErrorAlert } from 'smartsuite-ui';
import getUri from '../utils/getUri';

const LOG_ERROR_URL = getUri(`LoggingWebError/LogError`);
const UNAUTHORIZED_STATUS_CODE = 401;

function logError(errorObject, logErrorUrl) {
    if (logErrorUrl) {
        postDataPromise(logErrorUrl, errorObject);
    }
}

export default class ErrorBoundary extends Component {
    state = { errors: [] };

    componentDidCatch(errorObject) {
        if (errorObject.statusCode === UNAUTHORIZED_STATUS_CODE) {
            window.location.reload();
        }

        const currentDateTime = new Date();
        const timeout = currentDateTime.setSeconds(
            currentDateTime.getSeconds() + this.props.errorRetentionSeconds
        );
        const newError = {
            name: errorObject.message,
            stack: errorObject.stack,
            statusCode: errorObject.statusCode,
            timeout,
        };
        logError(newError, LOG_ERROR_URL);
        this.setState({
            // eslint-disable-next-line react/no-access-state-in-setstate
            errors: [...this.state.errors, newError],
        });
        this.props.raiseError(newError);
    }

    render() {
        const errors = filter(
            this.state.errors,
            (error) => new Date() < error.timeout
        );

        if (isEmpty(errors)) {
            return this.props.children;
        }

        return <ErrorAlert>{errors.join('\n')}</ErrorAlert>;
    }
}

ErrorBoundary.defaultProps = {
    raiseError: () => {},
    errorRetentionSeconds: 60,
};

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    errorRetentionSeconds: PropTypes.number,
    raiseError: PropTypes.func,
};
